import { render, staticRenderFns } from "./TagMappingHeaderToolbar.vue?vue&type=template&id=ea771cba&"
import script from "./TagMappingHeaderToolbar.vue?vue&type=script&lang=ts&"
export * from "./TagMappingHeaderToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports